import { CloseSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { Button, LinkButton, Modal } from '@pmi/dsm-react';
import { PlusIcon } from '@pmi/dsm-react/dist/components/icons/16';
import React, { useEffect, useState } from 'react';
import { PAY_BY_USER_STATUS_MAP } from '../../../../../shared/constants';
import styles from './enhancedEnrollmentModal.module.scss';
import RenderHtml from '../../../../../shared/components/RenderHtml';
import { Product } from '../../../models';

interface CongratsProp {
  onCancel: () => void;
  availableProducts: Product[];
}

export default function CongratsModal({
  onCancel,
  availableProducts,
}: CongratsProp) {
  const otherProducts = availableProducts.filter(
    (p) =>
      p.type !== 'Membership' &&
      p?.callToAction &&
      !p.redeemed &&
      !p.callToAction.text
        ?.toLowerCase()
        .trim()
        .includes(PAY_BY_USER_STATUS_MAP.inCart),
  );
  const moreProductCount =
    otherProducts.length > 5 ? otherProducts.length - 5 : 0;
  const [toRenderProducts, setToRenderProducts] = useState<
    (Product & {
      button: {
        text: string;
        onClick: () => void;
        icon?: (props: { className?: string }) => React.ReactElement;
      };
    })[]
  >([]);
  const [hasLongTextButton, setHasLongTextButton] = useState(false);
  useEffect(() => {
    if (otherProducts.length > 0) {
      const temp = otherProducts
        .map((p) => {
          const card = document.getElementById(`pcard-${p.sku.toLowerCase()}`);
          const ctaBtn = card?.querySelector('.btn-card-cta, .btn-pbu');
          const ctaBtnText =
            p.callToAction?.text ?? ctaBtn?.textContent?.trim();
          if (card && ctaBtn) {
            return {
              ...p,
              button: {
                text: ctaBtnText,
                icon: p.isPayByUserProduct ? PlusIcon : undefined,
                onClick: () => {
                  onCancel();
                  ctaBtn.dispatchEvent(
                    new Event('click', {
                      bubbles: true,
                      cancelable: true,
                    }),
                  );
                },
              },
            };
          }
          return null;
        })
        .filter((p) => p != null);
      const renderProducts = temp.slice(0, 5).map((p) => {
        if (p.button.text.length > 12) {
          setHasLongTextButton(true);
        }
        return p;
      });
      setToRenderProducts(renderProducts);
    }
  }, []);

  return (
    <Modal
      show
      variant="input"
      backdrop="static"
      customClassName={`${styles.enhanceEnrollmentModal} ${styles.customStyleEnabled}`}
    >
      <div className={styles.benefitsContainer}>
        <div className="d-flex justify-content-between align-items-center pb-3">
          <RenderHtml
            html="Congrats you’re a member &#x1F389;"
            tag="span"
            className={styles.customHeader}
          />
          <div>
            <CloseSolidIcon className="cursor-pointer" onClick={onCancel} />
          </div>
        </div>
        <div className="border-top py-3">
          <span className="d-block mb-2">
            <strong>Additional Products Available</strong>
          </span>
          <p className="mb-3">
            You still have more products to redeem at the bottom of the page
            under &quot;Available to Redeem&quot;.
          </p>
          <div className="d-block">
            <ul className="list-unstyled">
              {toRenderProducts.map((p, i) => (
                <li
                  className={`${
                    i < toRenderProducts.length - 1 ? 'border-bottom' : ''
                  } py-3 d-flex`}
                >
                  <div className="d-block flex-grow-1 pt-2">
                    <RenderHtml html={p.name} tag="span" />
                  </div>
                  <div className="d-block">
                    <LinkButton
                      variant="outline-secondary"
                      titleText={p.button.text}
                      size="sm"
                      style={{ width: hasLongTextButton ? '200px' : '135px' }}
                      icon={p.button.icon}
                      onClick={p.button.onClick}
                    />
                  </div>
                </li>
              ))}
              {moreProductCount > 0 && (
                <li className="text-center border-top pt-3">
                  +{moreProductCount} more available product
                  {moreProductCount > 1 ? 's' : ''}
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="d-flex align-center justify-content-end pt-3 border-top">
          <Button
            titleText="Close"
            variant="primary"
            size="sm"
            onClick={onCancel}
          />
        </div>
      </div>
    </Modal>
  );
}
